import {Grid} from '@primer/react-brand/esm'

import {CommunityFooter, type CommunityFooterProps} from '../../generic/CommunityFooter/CommunityFooter'
import {MonaFooter, type MonaFooterProps} from '../../generic/MonaFooter/MonaFooter'

import Styles from './FooterSection.module.css'

export interface FooterSectionProps {
  monaFooter: MonaFooterProps
  communityFooter: CommunityFooterProps
}

export type FooterSectionPropsData = Omit<FooterSectionProps, 'monaFooter'> & {
  monaFooter: {
    mona?: Pick<MonaFooterProps['mona'], 'alt'>
    repos: Omit<MonaFooterProps['repos'], 'items'>
  }
}

export const defaultProps: Partial<FooterSectionProps> = {}

export const FooterSection = (props: FooterSectionProps) => {
  const initializedProps: FooterSectionProps = {...defaultProps, ...props}
  const {monaFooter, communityFooter} = initializedProps

  return (
    <div className={Styles['FooterSection']}>
      <div className={Styles['FooterSection__gridFrame']}>
        <div className={Styles['FooterSection__gridContent']}>
          <Grid columnGap="none" rowGap="none" enableGutters={false}>
            <Grid.Column span={12} className={Styles['FooterSection__gridColumn']}>
              <MonaFooter {...monaFooter} />
              <CommunityFooter {...communityFooter} />
            </Grid.Column>
          </Grid>
        </div>
      </div>

      <div className={Styles['FooterSection__Spacer']} />
    </div>
  )
}
